import { PERSONAL_CHAT_INACTIVE_MS } from "../../../shared/personalChatInactivity";
import { Button } from "../Button";
import { Modal } from "../Modal";
import { Text } from "../Text";
import {
  ModalBody,
  ModalContent,
  ModalList,
  ModalTitleBlock,
  PersonalChatListRow,
} from "./PersonalChatListModal";

type StaleChat = {
  id: string;
  name: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  staleChats: readonly StaleChat[];
  onCloseAll: () => void;
  onOpenChat: (id: string) => void;
};

export function TidyUpPersonalChatsModal({
  open,
  onClose,
  staleChats,
  onCloseAll,
  onOpenChat,
}: Props) {
  const inactiveHours = PERSONAL_CHAT_INACTIVE_MS / (60 * 60 * 1000);

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContent>
        {staleChats.length > 0 ? (
          <>
            <ModalTitleBlock>
              <Text variant="text-regular-md" color="var(--text-primary)">
                Tidy up
              </Text>
              <Text variant="text-regular" color="var(--text-secondary)">
                You have {staleChats.length}{" "}
                {staleChats.length === 1 ? "chat" : "chats"} with no messages in
                the last {inactiveHours} hours. Close{" "}
                {staleChats.length === 1 ? "it" : "them"} to keep things tidy.
              </Text>
            </ModalTitleBlock>
            <ModalBody>
              <ModalList>
                {staleChats.map((chat) => (
                  <PersonalChatListRow
                    key={chat.id}
                    id={chat.id}
                    name={chat.name}
                    showArrow
                    onClick={() => onOpenChat(chat.id)}
                  />
                ))}
              </ModalList>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button size="l" onClick={onCloseAll}>
                  {staleChats.length === 1 ? "Close" : "Close all"}
                </Button>
              </div>
            </ModalBody>
          </>
        ) : (
          <ModalTitleBlock>
            <Text variant="text-regular-md" color="var(--text-primary)">
              Tidy up
            </Text>
            <Text variant="text-regular" color="var(--text-secondary)">
              Nothing to tidy — you've sent messages in all your open chats
              within the last {inactiveHours} hours. You're already on top of
              things.
            </Text>
          </ModalTitleBlock>
        )}
      </ModalContent>
    </Modal>
  );
}
